import {mapActions, mapMutations, mapState} from "vuex";

export const imageMixin = {
  computed: {
    ...mapState('common/file', ['noImageUrl']),
  },

  methods: {
    ...mapActions('common/file', ['fetchReportImage']),
    ...mapMutations('common/file', ['setNoImageUrl']),

    getImageURL(imageCode, large = false) {
      if (!imageCode) {
        return this.noImageUrl;
      }
      return this.$config.axios.browserBaseURL + 'images/' + imageCode
    },
    async initNoImageUrl() {
      if (this.noImageUrl === '') {
        const noImage = await this.fetchReportImage();
        const lNoImageUrl = noImage?.details?.no_image_available?.fieldValue?.fullFileUrl || '/UnavailableSmall.png';
        this.setNoImageUrl({ noImageUrl: lNoImageUrl });
      }
    },
    chooseImageUrl(item) {
      if (item.orderItemImageBinaryContentCode) {
        return this.getImageURL(item.orderItemImageBinaryContentCode);
      } else if (item.imageBinaryContentCode) {
        return this.getImageURL(item.imageBinaryContentCode);
      } else if (item.thumbnailBinaryCode) {
        return this.getImageURL(item.thumbnailBinaryCode);
      } else {
        return this.noImageUrl;
      }
    }
  },
}
